const modules = [];

function importAll(webpackContext) {
  // the webpackContext parameter is a function returned after invoking require.context() that has
  // access to all of the resolved paths defined in the require.context call.
  // The keys will be an array of all of the resolved module paths returned from the initial
  // require.context invocation within the importAll invocation a number of lines below this declaration.
  const keys = webpackContext.keys();
  keys.sort((a, b) => a.length - b.length);
  keys.forEach(modulePath => modules.push(webpackContext(modulePath).default));
}

importAll(require.context('../app/translations/', true, /\.js$/));
importAll(require.context('../app/services/', true, /\.js$/));
importAll(require.context('../app/modules/', true, /[d|D]irectives\.js$/));
importAll(require.context('../app/modules/', true, /module\.js$/));
importAll(require.context('../app/modules/', true, /component\.js$/));
importAll(require.context('../app/modules/', true, /\.js$/));
importAll(require.context('../app/filters/', true, /\.js$/));

const templates = require.context("../app", true, /\.html$/);
const addTemplates = $templateCache => {
  templates.keys().forEach(file => {
    // Substring removes . at the start of ./modules since angular requires it to be root /modules
    $templateCache.put(file.substring(1), templates(file).default);
  });
};

angular.module('templates', []).run(['$templateCache', function ($templateCache) {
  addTemplates($templateCache);
}]);